// Central SEO configuration for Cultiv AI Studio.
// Edit SITE_URL here when the production domain is finalized — every useSEO()
// call, canonical tag, and OG tag picks it up automatically.

export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://cultiv-ai.studio').replace(/\/+$/, '');

export const SITE_NAME = 'Cultiv AI Studio';

// Use a file that exists in /public (add og-default.jpg later for 1200×630 previews).
export const DEFAULT_OG_IMAGE = `${SITE_URL}/favicon.png`;

export const FALLBACK_OG_IMAGE = `${SITE_URL}/favicon.png`;

export const TWITTER_HANDLE = '@cultivaistudio';

// Map known routes -> default SEO payload. Individual pages can override.
export const ROUTE_DEFAULTS = {
  '/': {
    title: 'Cultiv AI Studio | AI Creative Agency for Viral Marketing Campaigns',
    description:
      'Cultiv AI Studio is an AI-first creative agency building viral video, image, and brand campaigns in days, not months. Cut production time 10x, ship content that converts.',
    keywords:
      'AI creative agency, AI marketing, AI video production, AI ad creatives, viral marketing, AI brand campaigns, generative AI studio',
  },
  '/portfolio': {
    title: 'Portfolio — AI Viral Case Studies & Creative Work | Cultiv AI Studio',
    description:
      'Explore Cultiv AI Studio\'s portfolio of AI-generated brand mockups, mobile UI, fintech web design, 3D product visuals, gaming assets, and viral social campaigns. Real results, zero production days.',
    keywords: 'AI portfolio, AI case studies, viral campaigns, AI brand design, AI video portfolio',
  },
  '/ai-creatives': {
    title: 'AI Creatives Gallery — Videos, Art & Brand Visuals | Cultiv AI Studio',
    description:
      'Browse 100+ AI-generated creatives from Cultiv AI Studio — videos, portraits, brand designs, 3D renders, and Gemini visuals. A live gallery of what\'s possible with generative AI.',
    keywords: 'AI creative gallery, AI generated art, AI videos, Gemini AI images, AI portraits',
  },
  '/contact': {
    title: 'Contact Cultiv AI Studio — Book Your AI Campaign Strategy Call',
    description:
      'Ready to launch your next viral AI campaign? Book a free 30-minute strategy call with Cultiv AI Studio. Stop wasting budget on slow production — build your AI marketing engine today.',
    keywords: 'contact Cultiv AI Studio, AI marketing consultation, AI campaign strategy call',
  },
};

export const buildCanonical = (pathname = '/') => {
  const path = pathname.split('?')[0].split('#')[0];
  const normalized = path === '' ? '/' : path;
  return `${SITE_URL}${normalized}`;
};
